import { jsx as _jsx } from "react/jsx-runtime";
import { COLOR_TOKENS } from '@backrs_ui/common-ui/src/designSystem/colors/colors';
import { Box } from '@mui/material';
import { Chart as ChartJS, ArcElement, Tooltip } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
var FIGMA_CHART_DIAMETER = 120;
ChartJS.register(ArcElement, Tooltip);
export var DonutChart = function (_a) {
    var percentageFilled = _a.percentageFilled;
    var safeValue = Math.min(100, Math.max(0, percentageFilled));
    var chartData = {
        datasets: [
            {
                data: [safeValue, 100 - safeValue],
                backgroundColor: [
                    COLOR_TOKENS['Colors/Border/border-brand'],
                    COLOR_TOKENS['Colors/Border/border-secondary'],
                ],
                borderColor: COLOR_TOKENS['Colors/Base/Black'],
                borderWidth: 1,
                borderRadius: 0,
                weight: 1,
            },
        ],
    };
    var options = {
        responsive: true,
        maintainAspectRatio: true,
        aspectRatio: 1,
        cutout: '50%',
        plugins: {
            legend: {
                display: false,
            },
            tooltip: {
                enabled: false,
            },
        },
        rotation: (-90 * Math.PI) / 180,
    };
    return (_jsx(Box, { sx: containerSx, children: _jsx(Doughnut, { data: chartData, options: options }) }));
};
var containerSx = {
    width: "".concat(FIGMA_CHART_DIAMETER, "px"),
    height: "".concat(FIGMA_CHART_DIAMETER, "px"),
};
